import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Classification } from 'contracts/Classifications';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_CLASSIFICATION_',
  }
);

export interface FetchClassificationState {
  data: Classification | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchClassificationRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Classification;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchClassificationState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchClassificationState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchClassificationState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchClassificationState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchClassificationState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchClassification = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchClassificationTypes = Types;
export const FetchClassificationActions = Creators;
